import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [{
    question: '¿Funciona si nunca tuve mucho éxito con las mujeres?',
    answer: 'Sí. El sistema está diseñado exactamente para eso. No necesitás experiencia previa — necesitás el método.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Al confirmar el pago recibís acceso inmediato. En menos de 5 minutos estás adentro.'
  }, {
    question: '¿Es para hombres de cualquier edad?',
    answer: 'Está optimizado para hombres de 30 a 45 años. Situaciones reales de esa etapa de vida.'
  }, {
    question: '¿Tiene garantía real?',
    answer: '7 días, devolución completa, sin preguntas. Sin formularios.'
  }];
  return <section className="py-24 md:py-32 px-4 bg-bg-card" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary font-display font-bold text-3xl md:text-4xl mb-4 text-center" data-id="element-88">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </motion.h2>
        <div className="w-12 h-[3px] bg-gold-primary rounded-sm mx-auto mb-14" data-id="element-89" />

        <div className="space-y-4" data-id="element-90">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`border border-border-subtle rounded-xl overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-section-alt border-l-[3px] border-l-gold-primary' : 'bg-bg-card'}`} data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === i ? -1 : i)} className="w-full p-6 flex items-center justify-between text-left hover:bg-bg-section-alt transition-colors" data-id="element-92">
                <span className="text-text-primary font-bold text-lg pr-4" data-id="element-93">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-94">
                  <ChevronDown className="text-gold-primary flex-shrink-0" size={24} data-id="element-95" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-96">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-97">
                    <div className="px-6 pb-6 text-text-secondary text-base leading-relaxed" data-id="element-98">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}